// import "./ArrowButton.css";
import { Compass, Grid3x3 } from "lucide-react";

import { useMenu } from "../context/MenuContext";

const ViewToggleButton = ({ isOpen }) => {
const { viewMode, setViewMode } = useMenu();
    const str = viewMode === "grid" ? "carte" : "damier";
    return (
        <button
            className={`view-toggle-btn ${isOpen ? "open" : "closed"}`}
            onClick={() => setViewMode(viewMode === "grid" ? "geo" : "grid")}
            title={`Basculer vers la vue ${viewMode === "grid" ? "carte" : "grille"}`}
            type="button"

            aria-label={`Basculer vers la vue ${viewMode === "grid" ? "carte" : "grille"}`}
            aria-pressed={viewMode === "geo"}
        >
            {viewMode === "grid" ? <Compass size={16} strokeWidth={2} /> : <Grid3x3 size={16} strokeWidth={2} />}{isOpen && str}

        </button>
    )
};

export default ViewToggleButton;